<template>
	<ConfirmModal
		class="delete-item-modal"
		primary-btn-class="button--danger"
		:title="title"
		:confirm-label="transUcfirst('commons.yes_delete')"
		:cancel-label="transUcfirst('commons.cancel')"
		@cancel="handleCancel"
		@confirm="handleConfirm"
	>
		<!-- body -->
		<template #body>
			<p>
				{{ body }}
				<template v-if="target">
					<strong>{{ target }}</strong>?
				</template>
			</p>
		</template>
	</ConfirmModal>
</template>

<script>
import ConfirmModal from './ConfirmModal.vue';

export default {
	name:       'DeleteModal',
	components: { ConfirmModal },
	props:      {
		title: {
			type:    String,
			default: '',
		},
		body: {
			type:    String,
			default: '',
		},
		target: {
			type:    String,
			default: '',
		},
	},
	methods: {
		handleConfirm() {
			this.$emit('confirm');
		},
		handleCancel() {
			this.$emit('cancel');
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
